import { EntityKeyByReference, Note } from '@card-software/library';
import { ProductRecipe } from '../item/product-recipe';
import { StatusHistoryEntry } from '../inventory/goods-receipt';

export interface ProductionWorkOrder {
  id: string;
  number: string;
  status: ProductionWorkOrderStatus;
  plantCode: string;
  items: ProductionWorkOrderItem[];
  notes?: Note[];
  estimatedStartDate?: string;
  estimatedEndDate?: string;
  statusHistory?: StatusHistoryEntry<ProductionWorkOrderStatus>[];
}

export interface ProductionWorkOrderItem {
  id: string;
  productRecipeNumber: string;
  productRecipe?: ProductRecipe;
  uom: number;
  quantity: number;
  reservations: ProductionWorkOrderReservation[];
}

export interface ProductionWorkOrderReservation {
  clientPurchaseOrderReference: string;
  clientPurchaseOrderNumber: string;
  clientPurchaseOrderItemId: string;
  clientPurchaseOrderProductRecipeNumber: string;
  reservedQuantity: number;
}

export interface ProductionWorkOrderSearchCommand {
  number?: string;
  plantCode?: string;
  status?: ProductionWorkOrderStatus[];
  itemCodes?: string[];
}

export enum ProductionWorkOrderStatus {
  Draft = 0,
  Approved = 1,
  InProduction = 2,
  Completed = 3,
  Cancelled = 98,
  Deleted = 99,
}

export interface Batch {
  id: string;
  number: string;
  status: BatchStatus;
  type: BatchType;
  productDevelopmentNumber: string;
  productRecipe?: ProductRecipe;
  uom: number;
  initiator: EntityKeyByReference;
  plannedQuantity: number;
  actualQuantity?: number;
  assetId?: string;
  notes?: Note[];
  statusHistory?: StatusHistoryEntry<BatchStatus>[];
}

export enum BatchStatus {
  Draft = 0,
  Approved = 1,
  ReadyForProduction = 2,
  InProduction = 3,
  Completed = 4,
  Closed = 5,
  Cancelled = 98,
  Deleted = 99,
}

export enum BatchType {
  Chemical = 0,
}

export interface BatchInsert {
  status: BatchStatus;
  type: BatchType;
  productDevelopmentNumber: string;
  uom: number;
  initiator: EntityKeyByReference;
  plannedQuantity: number;
  assetId?: string;
  notes?: Note[];
}

export interface BatchSearchCommand {
  number?: string;
  initiatorReference?: string;
  status?: BatchStatus[];
  productDevelopmentNumber?: string;
  type?: BatchType;
}

export interface ProductionWorkOrderInsert {
  status: ProductionWorkOrderStatus;
  items: ProductionWorkOrderItemInsert[];
  notes?: Note[];
  estimatedStartDate?: string;
  estimatedEndDate?: string;
}

export interface ProductionWorkOrderItemInsert {
  productRecipeNumber: string;
  uom: number;
  quantity: number;
  reservations: ProductionWorkOrderReservationInsert[];
}

export interface ProductionWorkOrderReservationInsert {
  clientPurchaseOrderReference: string;
  clientPurchaseOrderNumber: string;
  clientPurchaseOrderItemId: string;
  clientPurchaseOrderProductRecipeNumber: string;
  reservedQuantity: number;
}
